<template>
  <div class="monitoring">
    <div class="p-1 bg-black rounded" name="header" style="height:675px;">
        <div class="row">
            <div class="col-md-3">
                <p class="fs-2 fw-light text-white text-center mt-2 ms-2" style="letter-spacing: 10px;">Monitoring</p>
            </div>
            <div v-if="header == 'filter'" class="col-md-6">
                <div class="input-group flex-nowrap mt-2">
                    <input class="btn fw-light bg-synapse-glass text-white fs-4 w-100 me-1" type="text" style="cursor: default;" placeholder="Filter by keyword" v-model="searchWord">
                    <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='name', 'btn-synapse-dark': searchType=='name'}" @click="setSearchType('name')" title="Filter by Name">
                        <i class="fa-solid fa-desktop"></i>
                    </button>
                    <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='alias', 'btn-synapse-dark': searchType=='alias'}" @click="setSearchType('alias')" title="Filter by Alias">
                        <i class="fa-solid fa-id-badge"></i>
                    </button>
                    <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='type', 'btn-synapse-dark': searchType=='type'}" @click="setSearchType('type')" title="Filter by Type">
                        <i class="fa-solid fa-cubes"></i>
                    </button>
                    <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='category', 'btn-synapse-dark': searchType=='category'}" @click="setSearchType('category')" title="Filter by Category">
                        <i class="fa-solid fa-cube"></i>
                    </button>
                </div>
            </div>
            <div v-if="header == 'message'" class="col-md-6">
                <div v-if="autoRefresh" class="input-group flex-nowrap mt-3">
                    <input class="btn fw-light bg-transparent text-white fs-6 w-30 me-1" type="text" style="cursor: default;"  :value="`${mn_status.ts}`" readonly>
                    <input class="btn fw-light bg-transparent text-white fs-6 w-30 me-1" type="text" style="cursor: default;"  :value="`${mn_status.status.timestamp}`" readonly>
                    <input class="btn fw-light bg-transparent text-white fs-6 w-100 me-1" type="text" style="cursor: default;"  :value="`${mn_status.status.text}`" readonly>
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group flex-nowrap mt-2">
                    <button class="btn btn-synapse-dark fs-4 rounded me-2 w-50" @click="toggleHeader">
                        <i class="fa-solid" :class="{'fa-message': header=='filter', 'fa-filter': header=='message'}"></i>
                    </button>
                    <button class="btn btn-synapse-dark fs-4 rounded me-2 w-50" @click="toggleAutoRefresh(); header='message'">
                        <i class="fa-solid fa-compass" :class="{'fa-spin text-warning': autoRefresh}"></i>
                    </button>
                    <button class="btn btn-synapse-dark fs-4 rounded w-50" @click="getProbes">
                        <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingProbes}"></i>
                    </button>
                </div>
            </div>
            <div v-if="false" class="col-md-1">
                <div class="input-group flex-nowrap mt-2">
                    <button class="btn btn-synapse-dark fs-4 rounded me-2 w-100" @click="mode = 'table'; getProbes();" :disabled="gettingProbes">
                        <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingProbes}"></i>
                    </button>
                    <button v-if="false" class="btn btn-synapse-dark rounded fs-3 w-50" @click="mode = 'space'; getTopology();" :disabled="gettingTopology">
                        <i class="fa-solid fa-circle-nodes" :class="{'fa-spin': gettingTopology}"></i>
                    </button>
                </div>
            </div>
            
        </div>
        
        <!-- Table -->
        <div v-if="mode=='table'">
            <div class="p-2" v-show="mode=='table'">
                <div v-show="gettingProbes" class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <div class="input-group flex-nowrap w-100" style="margin-top: 40%;">
                            <button class="btn bg-transparent text-white fs-1 w-100">
                                <i class="fa-solid fa-rocket fa-beat"></i>
                                <p>Retrieving probes...</p>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="!gettingProbes" class="row">
                    <div class="col-md-12">
                        <div class="border-top-synapse rounded p-1" :class="{'disabled-div': gettingProbes || deletingProbe || poweringProbe}">
                            <div class="tableFixHead mt-1" style="height: 560px;">
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="#">
                                                <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 border-bottom-synapse" style="color: rgb(52, 143, 186); width: 120px;" title="Name/Alias">
                                                <select v-model="searchType_ind" class="btn btn-black fs-5" style="color: rgb(52, 143, 186);">
                                                    <option value="name">Name</option>
                                                    <option value="alias">Alias</option>
                                                </select>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 30px;" title="Connectivity">
                                                <i class="fa-solid fa-lg fa-tower-broadcast"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 30px;" title="Type">
                                                <i class="fa-solid fa-lg fa-cubes"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 50px;" title="Category">
                                                <i class="fa-solid fa-lg fa-cube"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 30px;" title="Latency.">
                                                <i class="fa-solid fa-lg fa-clock"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Similarity.">
                                                <i class="fa-solid fa-lg fa-percent"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Hops (Only for traceroute).">
                                                <i class="fa-solid fa-lg fa-frog"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 30px;" title="Type">
                                                <i class="fa-solid fa-lg fa-info"></i>
                                            </th>
                                            <th class="fw-light bg-black fs-5 rounded border-bottom-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Delete probe.">
                                                <i class="fa-solid fa-lg fa-eye"></i>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(p, i) in filteredProbes" v-bind:key="i+1"> <!-- Content Row -->
                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                                <input type="text" class="btn bg-black text-white fw-light fs-5 text-center border-0 w-100" style="cursor: default;" :value="i+1" readonly>
                                            </td>
                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                                <input type="text" class="btn bg-black text-white fw-light fs-5 text-center border-0 w-100" :class="{'fa-fade': p.status == 0}" style="cursor: default;" :value="p[searchType_ind]" readonly>
                                            </td>
                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.connectivity != 0, 'btn-synapse-danger': p.connectivity == 0}" title="Connectivity">
                                                    <i class="fa-solid fa-lg fa-tower-broadcast" :class="{'fa-fade': !p.connectivity}"></i>
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.status != 0, 'btn-synapse-danger': p.status == 0}" :title="`Probe type: ${p.type}`">
                                                    <i class="fa-solid fa-lg" :class="{'fa-globe': p.type =='url', 'fa-database': p.type =='databank', 'fa-rss': p.type == 'ping', 'fa-road': p.type =='traceroute', 'fa-fade': p.status==0}"></i>
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.status != 0, 'btn-synapse-danger': p.status==0}" :title="`Probe category: ${p.category}`">
                                                    <span :class="{'fa-fade': p.status == 0}">{{String(p.category).toUpperCase()}}</span>
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button v-if="p.latency == null" class="btn fw-light bg-synapse-glass text-white fs-6 w-100" title="Latency not registered." readonly>
                                                -
                                                </button>
                                                <button v-if="p.latency != null && p.latency_tolerance == null" class="btn fw-light fs-6 w-100 btn-synapse-dark" :title="`Latency: ${p.latency} ms - No latency tolerance.`" readonly>
                                                {{p.latency}} ms
                                                </button>
                                                <button v-if="p.latency != null && p.latency_tolerance != null" class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.latency < p.latency_tolerance, 'btn-synapse-danger': p.latency >= p.latency_tolerance }" :title="`Latency: ${p.latency} ms / Tolerance: ${p.latency_tolerance} ms`" readonly>
                                                {{p.latency}} ms
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button v-if="p.similarity == null" class="btn fw-light bg-synapse-glass text-white fs-6 w-100" title="Similarity not registered." readonly>
                                                -
                                                </button>
                                                <button v-if="p.similarity != null && p.similarity_tolerance == null" class="btn fw-light fs-6 w-100 btn-synapse-dark" :title="`Similarity: ${p.similarity} % - No similarity tolerance.`" readonly>
                                                {{p.similarity}} %
                                                </button>
                                                <button v-if="p.similarity != null && p.similarity_tolerance != null" class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.similarity > p.similarity_tolerance, 'btn-synapse-danger': p.similarity <= p.similarity_tolerance }" :title="`Similarity: ${p.similarity} % / Tolerance: ${p.similarity_tolerance} %`" readonly>
                                                {{p.similarity}} %
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button v-if="p.trace_length == null" class="btn fw-light bg-synapse-glass text-white fs-6 w-100" title="Traceroute length not registered." readonly>
                                                -
                                                </button>
                                                <button v-if="p.trace_length != null" class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.status != 0, 'btn-synapse-danger': p.status == 0 }" :title="`Traceroute length/ Number of hops: ${p.trace_length}`" readonly>
                                                {{p.trace_length}}
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.status != 0, 'btn-synapse-danger': p.status == 0}" title="Status" @click="viewElement(p); sev_mode='alerts'" :disabled="autoRefresh">
                                                    <i class="fa-solid fa-lg" :class="{'fa-check': p.status != 0, 'fa-triangle-exclamation fa-fade': p.status == 0}"></i>
                                                </button>
                                            </td>
                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                                <button class="btn btn-synapse-dark fw-light fs-6 w-100" @click="viewElement(p); sev_mode='info'" :disabled="autoRefresh">
                                                    <i class="fa-solid fa-lg fa-eye" :class="{'fa-fade': p.status==0}"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Space -->
        <div v-if="false" class="p-1" v-show="mode=='space'">
            <div v-show="gettingTopology" class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <div class="input-group flex-nowrap w-100" style="margin-top: 40%;">
                        <button class="btn bg-transparent text-white fs-1 w-100">
                            <i class="fa-solid fa-circle-nodes fa-spin"></i>
                            <p>Generating topology...</p>
                        </button>
                    </div>
                </div>
            </div>
            <div v-show="!gettingTopology" class="row">
                <!-- The space. -->
                <div  class="" style="height: 550px;">
                    <Topology :ref="spacename"
                                constructionTitle="" 
                                constructionID="SpaceOneId" 
                                constructionSite="SpaceOne"
                                constructionTheme="yellow"
                                titleColor="ionic-white"
                                titleSize="ionic-title-lg"
                                :topologyData="topology_data"
                                :icons="icons"
                                outterEventName="viewElement" 
                                @viewElement="viewElement($event)"></Topology>
                </div>
            </div>
        </div>



        <!-- Single Element View -->
        <button id="sv-btn" style="display: none;" data-bs-toggle="modal" data-bs-target="#single-view"></button>
        <div class="modal fade" id="single-view" tabindex="-1" >
            <div class="modal-xl modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div v-if="se!=null" class="modal-content bg-black">
                    <!-- Header -->
                    <div class="modal-header" style="border-bottom: solid 2px rgb(0, 54, 73);">
                        <div class="input-group flex-nowrap w-100">
                            <button class="btn bg-black text-white text-start fs-2" style="width: 90%; letter-spacing: 4px; cursor: default;">{{se.alias}} : Detail</button>
                            <button class="btn btn-synapse-dark rounded me-3" title="Close probe results." style="width: 10%;" @click="sev_mode = 'info'">
                                <i class="fa-solid fa-2xl fa-eye"></i>
                            </button>
                            <button v-if="se.type!='traceroute'" class="btn btn-synapse-dark rounded me-3" title="Close probe results." style="width: 10%;" @click="sev_mode = 'graph'; getProbeGraph(); samplesGraph=100;" :disabled="gettingGraph">
                                <i class="fa-solid fa-2xl fa-chart-line" :class="{'fa-fade': gettingGraph}"></i>
                            </button>
                            <button v-if="se.type=='traceroute'" class="btn btn-synapse-dark rounded me-3" title="View traceroute hops." style="width: 10%;" @click="sev_mode = 'hops'">
                                <i class="fa-solid fa-2xl fa-frog"></i>
                            </button>
                            <button class="btn rounded me-3" :class="{'btn-synapse-dark': se.status != 0, 'btn-synapse-danger': se.status == 0 }"  title="View probe current alerts." style="width: 10%;" @click="sev_mode = 'alerts'">
                                <i class="fa-solid fa-2xl fa-triangle-exclamation"></i>
                            </button>
                            <button class="btn btn-danger rounded" title="Close probe results." data-bs-dismiss="modal" style="width: 10%;">
                                <i class="fa-solid fa-2xl fa-close"></i>
                            </button>
                        </div>
                    </div>
                    <!-- Body -->
                    <div class="modal-body bg-black">
                        <!-- Info & Content -->
                        <div v-show="sev_mode=='info'">
                            <div class="row">
                                <!-- Info -->
                                <div class="col-md-12">
                                    <!-- Info -->
                                    <div class="input-group flex-nowrap">
                                        <input type="text" class="btn fs-3 rounded w-100" :class="{'btn-synapse-dark': se.status, 'btn-synapse-danger fa-fade': !se.status}" :value="String(se.name)" title="Probe name." readonly>
                                    </div>
                                    <div class="input-group flex-nowrap mt-3">
                                        <button class="btn fs-3 rounded w-50 me-2" :class="{'btn-synapse-dark': se.status, 'btn-synapse-danger fa-fade': !se.status}" title="Probe type.">
                                            <i class="fa-solid me-1" :class="{'fa-rss': se.type=='ping', 
                                                                        'fa-database': se.type=='databank', 
                                                                        'fa-globe': se.type=='url'}"></i>
                                            {{capitalize(se.type)}}
                                        </button>
                                        <button class="btn fs-3 rounded w-50 ms-2" :class="{'btn-synapse-dark': se.status, 'btn-synapse-danger fa-fade': !se.status}" title="Probe category.">
                                            <i class="fa-solid me-1 fa-cube"></i>
                                            {{String(se.category).toUpperCase()}}
                                        </button>
                                    </div>
                                    <!-- Health -->
                                    <div class="mt-3 p-2 rounded bg-synapse-glass" style="height: 400px;">
                                        <p class="fw-light fs-2 text-white">Health</p>
                                        <!-- Latency -->
                                        <div v-if="Object.keys(se).includes('status')"  class="input-group flex-nowrap mt-3">
                                            <button class="btn fw-light text-white fs-3 w-25" :class="{'btn-synapse-dark': se.status, 'btn-synapse-danger': !se.status }" title="Probe status." readonly>
                                                <i class="fa-solid" :class="{'fa-check': se.status,'fa-triangle-exclamation fa-beat-fade': !se.status}"></i>
                                            </button>
                                            <input v-if="se.status" type="text" class="btn fs-3 bg-black text-white w-75 border-bottom" :value="'Working'" readonly>
                                            <input v-if="!se.status" type="text" class="btn fs-3 bg-black text-white w-75 border-bottom" :value="se.error || 'Alert detected.'" readonly>
                                        </div>
                                        <!-- Latency -->
                                        <div v-if="Object.keys(se).includes('latency')"  class="input-group flex-nowrap mt-3">
                                            <button v-if="se.latency == null" class="btn fw-light bg-synapse-glass text-white fs-3 w-25" title="Latency not registered." readonly>
                                                <i class="fa-solid fa-clock"></i>
                                            </button>
                                            <button v-if="se.latency != null && se.latency_tolerance == null" class="btn fw-light fs-3 w-25 btn-synapse-dark" :title="`Latency: ${se.latency} ms - No latency tolerance.`" readonly>
                                                <i class="fa-solid fa-clock"></i>
                                            </button>
                                            <button v-if="se.latency != null && se.latency_tolerance != null" class="btn fw-light fs-3 w-25" :class="{'btn-synapse-dark': se.latency < se.latency_tolerance, 'btn-synapse-danger': se.latency >= se.latency_tolerance }" :title="`Latency: ${se.latency} ms / Tolerance: ${se.latency_tolerance} ms`" readonly>
                                                <i class="fa-solid fa-clock" :class="{'fa-beat-fade': se.latency >= se.latency_tolerance}"></i>
                                            </button>
                                            <input type="text" class="btn fs-3 bg-black text-white w-75 border-bottom" :value="String(se.latency) + ' ms / ' + String(se.latency_tolerance) + ' ms'" readonly>
                                        </div>
                                        <!-- Similarity -->
                                        <div v-if="Object.keys(se).includes('similarity')" class="input-group flex-nowrap mt-3">
                                            <button v-if="se.similarity == null" class="btn fw-light bg-synapse-glass text-white fs-3 w-25" title="Similarity not registered." readonly>
                                                <i class="fa-solid fa-percent"></i>
                                            </button>
                                            <button v-if="se.similarity != null && se.similarity_tolerance == null" class="btn fw-light fs-3 w-25 btn-synapse-dark" :title="`Similarity: ${se.similarity} % - No similarity tolerance.`" readonly>
                                                <i class="fa-solid fa-percent"></i>
                                            </button>
                                            <button v-if="se.similarity != null && se.similarity_tolerance != null" class="btn fw-light fs-3 w-25" :class="{'btn-synapse-dark': se.similarity > se.similarity_tolerance, 'btn-synapse-danger': se.similarity <= se.similarity_tolerance }" :title="`Latency: ${se.similarity} ms / Tolerance: ${se.similarity_tolerance} ms`" readonly>
                                                <i class="fa-solid fa-percent"></i>
                                            </button>
                                            <input v-if="se.similarity == null" type="text" class="btn fs-4 bg-black text-white w-75 border-bottom" :value="'Similarity not registered.'" readonly>
                                            <input v-if="se.similarity != null" type="text" class="btn fs-3 bg-black text-white w-75 border-bottom" :value="String(se.similarity) + '%'" readonly>
                                        </div>
                                        <!-- Last Update -->
                                        <div class="input-group flex-nowrap mt-3">
                                            <button class="btn btn-synapse-dark fs-3 w-25" title="Last update.">
                                                <i class="fa-solid fa-timeline"></i>
                                            </button>
                                            <input type="text" class="btn fs-3 bg-black text-white w-75 border-bottom" :value="se.timestamp" :title="'Last update: ' + String(se.timestamp)" readonly>
                                        </div>
                                    </div>
                                </div>
                                <!-- Content -->
                                <div v-if="false" class="col-md-6">
                                    <div  class="p-2 rounded bg-synapse-glass" style="height: 100%;">
                                        <!-- Content-->
                                        <div v-if="se.type=='ping' || se.type=='databank'" class="mt-3" style="height: 85%;">
                                            <p class="fw-light fs-2 text-white">Content</p>
                                            <textarea class="btn w-100 text-white text-start fs-6" style="height: 100%; resize: none;" :value="se.content" readonly></textarea>
                                        </div>
                                        <div v-if="se.type=='url'" class="mt-3" style="height: 85%;">
                                            <p class="fw-light fs-2 text-white">Content</p>
                                            <!-- Content HTML-->
                                            <div v-if="se.category == 'html'" style="height: 100%;">
                                            <textarea class="btn w-100 text-white text-start fs-6" style="height: 100%; resize: none;" :value="se.content" readonly></textarea>
                                            </div>
                                            <!-- Content JSON-->
                                            <div v-if="se.category == 'json'" style="height: 100%;">
                                                <textarea class="btn w-100 text-white text-start fs-6" style="height: 100%; resize: none;" :value="se.content" readonly></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Graphs -->
                        <div v-show="sev_mode=='graph'">
                            <div v-if="gettingGraph" style="height: 540px;">
                                <button class="btn bg-transparent text-white w-100" style="margin-top: 20%;">
                                    <i class="fa-solid fa-2xl fa-chart-line fa-fade"></i>
                                </button>
                                <span class="text-white fs-3">Getting graph...</span>
                            </div>
                            <div v-if="!gettingGraph && readyGraph" class="p-2" style="height: 540px;">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div v-if="pgdata.analysis != null" class="bg-synapse-glass rounded p-2" style="height: 100%;">
                                            <span class="text-white fs-3">Analysis</span>
                                            <div class="input-group flex-nowrap mt-2">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Total elements.">
                                                    <i class="fa-solid fa-object-group"></i>
                                                </button>
                                                <input type="number" class="btn fs-5 bg-black text-white w-75 border-bottom" v-model.number="samplesGraph" :title="'Total elements: ' + String(samplesGraph)">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Set current samples." @click="getProbeGraph();">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                            </div>
                                            <div class="input-group flex-nowrap mt-2">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Maximum value.">
                                                    <i class="fa-solid fa-plus"></i>
                                                </button>
                                                <input type="text" class="btn fs-5 bg-black text-white w-75 border-bottom" :value="pgdata.analysis.max + ' ms'" :title="'Maximum value: ' + String(pgdata.analysis.max) + ' ms'" readonly>
                                            </div>
                                            <div class="input-group flex-nowrap mt-2">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Mean.">
                                                    <i class="fa-solid fa-plus-minus"></i>
                                                </button>
                                                <input type="text" class="btn fs-5 bg-black text-white w-75 border-bottom" :value="pgdata.analysis.mean + ' ms'" :title="'Mean value: ' + String(pgdata.analysis.mean) + ' ms'" readonly>
                                            </div>
                                            <div class="input-group flex-nowrap mt-2">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Minimum value.">
                                                    <i class="fa-solid fa-minus"></i>
                                                </button>
                                                <input type="text" class="btn fs-5 bg-black text-white w-75 border-bottom" :value="pgdata.analysis.min + ' ms'"  :title="'Minimum value: ' + String(pgdata.analysis.min) + ' ms'"  readonly>
                                            </div>
                                            <div class="input-group flex-nowrap mt-2">
                                                <button class="btn btn-synapse-dark fs-4 w-25" title="Standard deviation.">
                                                    <i class="fa-solid fa-chart-area"></i>
                                                </button>
                                                <input type="text" class="btn fs-5 bg-black text-white w-75 border-bottom" :value="pgdata.analysis.stdev + ' ms'"  :title="'Standard deviation: ' + String(pgdata.analysis.stdev) + ' ms'"  readonly>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="bg-synapse-glass rounded p-1" style="height: 485px; display: flex;">
                                            <ProbeGraph chart-id="probe_graph" :chart-data="pgdata"></ProbeGraph>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Hops details, only for traceroute. -->
                        <div v-show="sev_mode=='hops' && se.type=='traceroute'">
                            <div style="height: 540px;">
                                <div class="row">
                                    <div class="col-md-12">
                                        <input type="text" value="Hops Comparison" class="btn w-100 fw-bold fs-2 text-white">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-1">
                                        <button class="btn btn-synapse fs-4 w-100">
                                            <i class="fa-solid fa-frog"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-5">
                                        <input type="text" value="Previous" class="btn btn-synapse w-100 fw-light fs-4">
                                    </div>
                                    <div class="col-md-5">
                                        <input type="text" value="Current" class="btn btn-synapse w-100 fw-light fs-4">
                                    </div>
                                    <div class="col-md-1">
                                        <button class="btn btn-synapse fs-4 w-100">
                                            <i class="fa-solid fa-vials"></i>
                                        </button>
                                    </div>
                                </div>
                                <div v-if="se.content != null">
                                    <div class="row mt-2" v-for="(change, ic) in se.content.changes" v-bind:key="ic+1">
                                        <hr class="bg-white mt-2">
                                        <div v-if="!change.valid" class="mb-3 w-100">
                                            <input type="text" class="btn bg-transparent text-white w-100" :value="change.desc" readonly>
                                        </div>
                                        <!-- Hop -->
                                        <div class="col-md-1">
                                            <button class="btn fs-4 w-100" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                {{change.hop}}
                                            </button>
                                        </div>
                                        <!-- From -->
                                        <div class="col-md-5">
                                            <div v-if="change.from != null">
                                                <div v-if="change.from.branchs.length > 0">
                                                    <div v-for="(_from, fi) in change.from.branchs" v-bind:key="fi+1">
                                                        <div class="input-group flex-nowrap">
                                                            <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid && _from.ip != se.endpoint_ip, 
                                                                                                   'btn-synapse-danger': !change.valid, 
                                                                                                   'btn-success me-1': change.valid && _from.ip == se.endpoint_ip }">
                                                                <i class="fa-solid fa-globe"></i> 
                                                            </button>
                                                            <input type="text" class="btn fs-6 w-100" :value="_from.ip" :class="{'btn-synapse-dark': change.valid && _from.ip != se.endpoint_ip, 
                                                                                                                                 'btn-synapse-danger': !change.valid, 
                                                                                                                                 'btn-success me-1': change.valid && _from.ip == se.endpoint_ip }">
                                                            <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid && _from.ip != se.endpoint_ip, 
                                                                                                   'btn-synapse-danger': !change.valid, 
                                                                                                   'btn-success me-1': change.valid && _from.ip == se.endpoint_ip }">
                                                                <i class="fa-solid fa-clock"></i> 
                                                            </button>
                                                            <input type="text" class="btn fs-6 w-100" :value="_from.time +' ms'" :class="{'btn-synapse-dark': change.valid && _from.ip != se.endpoint_ip, 
                                                                                                                                          'btn-synapse-danger': !change.valid, 
                                                                                                                                          'btn-success': change.valid && _from.ip == se.endpoint_ip }">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="change.from.branchs.length == 0">
                                                    <div class="input-group flex-nowrap">
                                                        <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                            <i class="fa-solid fa-user-secret"></i> 
                                                        </button>
                                                        <input type="text" class="btn fs-6 w-75" value="Unknown Hop" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="change.from == null">
                                                <div class="input-group flex-nowrap">
                                                    <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                        <i class="fa-solid fa-ban"></i> 
                                                    </button>
                                                    <input type="text" class="btn fs-6 w-75" value="No existent hops." :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- To -->
                                        <div class="col-md-5">
                                            <div v-if="change.to != null">
                                                <div v-if="change.to.branchs.length > 0">
                                                    <div v-for="(_to, ti) in change.to.branchs" v-bind:key="ti+1">
                                                        <div class="input-group flex-nowrap">
                                                            <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid && _to.ip != se.endpoint_ip, 
                                                                                                                                 'btn-synapse-danger': !change.valid, 
                                                                                                                                 'btn-success me-1': change.valid && _to.ip == se.endpoint_ip }">
                                                                <i class="fa-solid fa-globe"></i> 
                                                            </button>
                                                            <input type="text" class="btn fs-6 w-100" :value="_to.ip" :class="{'btn-synapse-dark': change.valid && _to.ip != se.endpoint_ip, 
                                                                                                                                 'btn-synapse-danger': !change.valid, 
                                                                                                                                 'btn-success me-1': change.valid && _to.ip == se.endpoint_ip }">
                                                            <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid && _to.ip != se.endpoint_ip, 
                                                                                                                                 'btn-synapse-danger': !change.valid, 
                                                                                                                                 'btn-success me-1': change.valid && _to.ip == se.endpoint_ip }">
                                                                <i class="fa-solid fa-clock"></i> 
                                                            </button>
                                                            <input type="text" class="btn fs-6 w-100" :value="_to.time +' ms'" :class="{'btn-synapse-dark': change.valid && _to.ip != se.endpoint_ip, 
                                                                                                                                 'btn-synapse-danger': !change.valid, 
                                                                                                                                 'btn-success': change.valid && _to.ip == se.endpoint_ip }">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="change.to.branchs.length == 0">
                                                    <div class="input-group flex-nowrap">
                                                        <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                            <i class="fa-solid fa-user-secret"></i> 
                                                        </button>
                                                        <input type="text" class="btn fs-6 w-75" value="Unknown Hop" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="change.to == null">
                                                <div class="input-group flex-nowrap">
                                                    <button class="btn fs-4 w-25" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                        <i class="fa-solid fa-ban"></i> 
                                                    </button>
                                                    <input type="text" class="btn fs-6 w-75" value="No existent hops." :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Result -->
                                        <div class="col-md-1">
                                            <button class="btn fs-4 w-100" :class="{'btn-synapse-dark': change.valid, 'btn-synapse-danger': !change.valid}" :title="change.desc">
                                                <i class="fa-solid" :class="{'fa-check': change.valid, 'fa-x': !change.valid}"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="se.content == null">
                                    <button class="btn bg-transparent text-white w-100 fs-2 mb-2" style="margin-top: 15%;">
                                        <i class="fa-solid fa-2xl fa-ban fa-fade"></i>
                                    </button>
                                    <span class="text-white fs-3">Unavailable content.</span>
                                </div>
                            </div>
                        </div>
                        <!-- Alerts -->
                        <div v-if="sev_mode=='alerts' && se.content != null">
                            <div v-if="se.content.alerts.length > 0" style="height: 540px;">
                                <div class="row">
                                    <div class="col-md-4">
                                        <input type="text" value="Alerts" class="btn w-100 fw-bold fs-1 text-white text-start" readonly>
                                    </div>
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <input type="text" :value="se.timestamp" class="btn w-100 fw-light fs-2 text-white text-end mt-2" readonly>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-1">
                                        <button class="btn btn-synapse-dark fs-5 w-100">
                                            <i class="fa-solid fa-hashtag"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-3">
                                        <input type="text" value="Name" class="btn btn-synapse-dark w-100 fw-light fs-5" readonly>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="text" value="Description" class="btn btn-synapse-dark w-100 fw-light fs-5 text-start" readonly>
                                    </div>
                                </div>

                                <div class="row mt-3" v-for="(_alert, ia) in se.content.alerts" v-bind:key="ia+1">
                                    <hr class="bg-white">
                                    <div class="col-md-1">
                                        <button class="btn btn-synapse-danger fs-6 w-100">
                                            {{ia+1}}
                                        </button>
                                    </div>
                                    <div class="col-md-3">
                                        <input type="text" :value="capitalize(_alert.name.split('-').join(' '))" class="btn btn-synapse-danger w-100 fw-light fs-6" readonly>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="text" :value="_alert.description" class="btn btn-synapse-danger w-100 fw-light fs-6 text-start" readonly>
                                    </div>
                                </div>
                            </div>
                            <div v-if="se.content.alerts.length == 0" style="height: 540px;">
                                <button class="btn bg-transparent text-white w-100 fs-2 mb-2" style="margin-top: 15%;">
                                    <i class="fa-solid fa-2xl fa-check"></i>
                                </button>
                                <span class="text-white fs-3">No current alarms.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>




  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"
import Topology from '@/components/apps-components/synapse/subs/Topology.vue'
import ProbeGraph from '@/components/apps-components/synapse/subs/ProbeGraph.vue'

import axios from "axios";

export default {
  name: 'Devices',
  components: {
    Topology,
    ProbeGraph
  },
  data(){
    return {
      // General
        site: null,
        stage: null,
        mode: "table",
      // Topology
        gettingTopology: false,
        spacename: "space",
        topology_data: {
            nodes: [],
            links: [],
            nodeSet: []
        },
        se: null,
        sev_mode: 'info',
        gettingGraph: false,
        readyGraph: false,
        samplesGraph: 100,
        pgdata: {labels: [], datasets:[], analysis: null},
        // Icons
        icons: {
            synapse: require("@/assets/synapse-icons/synapse-icon.png"),
            urls: require("@/assets/synapse-icons/urls-icon.png"),
            url_html: require("@/assets/synapse-icons/url-html-icon.png"),
            url_json: require("@/assets/synapse-icons/url-json-icon.png"),
            databanks: require("@/assets/synapse-icons/databanks-icon.png"),
            databank_mysql: require("@/assets/synapse-icons/databank-mysql-icon.png"),
            pings: require("@/assets/synapse-icons/pings-icon.png"),
            ping_icmp: require("@/assets/synapse-icons/ping-icon.png")
        },
        spacekey: 0,
      // Monitoring
        arid: null,
        autoRefresh: false,
        mn_status: {
            status: { text: '', timestamp: '' },
            message: '',
            ts: ''
        },
        header: 'filter',


      // Probes
        gettingProbes: false,
        probes: [],
        probe: {},
        poweringProbe: false,
      
      // Testing
        test_results: null,
      // Delete
        deletingProbe: false,
      // Edition
        eprobe: {
            type: null
        },
        deprobe: {
            type: null
        },
      // Edit device
        savingProbe: false,

      // Filtering
        searchWord: "",
        searchType: "alias",
        searchType_ind: "alias"
    }
  },
  methods:{
    // Probes
    getProbes(){
        this.gettingProbes = true
        const params = {}
        const dest = this.site + '/synapse/monitoring/getProbes' 
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.probes = rx.data.probes
                this.gettingProbes = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingProbes = false
        });
    },

    getMonitoringStatus(){
        const params = {listener: this.arid}
        const dest = this.site + '/synapse/monitoring/getMonitoringStatus'
        axios
            .get(dest, {params})
            .then(rx => {
                this.mn_status = rx.data
                console.log(this.mn_status)
                if (this.mn_status.update){
                    this.getProbes()
                    console.log('UPDATE')
                }
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
            });
    },
    startChecking(){
      // Verify the listener.
      this.pollingListener = String(localStorage.getItem('synapsePollingListener'))
      
      if (this.pollingListener == 'null'){
        //console.log('No existente, creando...')
        this.pollingListener = setInterval(this.getMonitoringStatus, 1000)
        localStorage.setItem('synapsePollingListener', this.pollingListener)
      }
      else{
        clearInterval(parseInt(this.pollingListener))
        this.pollingListener = setInterval(this.getMonitoringStatus, 1000)
        localStorage.setItem('synapsePollingListener', this.pollingListener)
      }
    },
    toggleAutoRefresh(){
        if (this.autoRefresh){
            try {
                clearInterval(this.arid)
                //alert('Stopped: ' + String(this.arid))
            } catch (error) {
                alert(error)
            }
        }
        else{
            this.arid = setInterval(this.getMonitoringStatus, 1000)
        }
        this.autoRefresh = !this.autoRefresh
    },
    toggleHeader(){
        if (this.header == 'filter') { this.header = 'message' }
        else if (this.header == 'message') { this.header = 'filter' }
    },

    // Topology
    getTopology(){
        this.gettingTopology = true
        const params = {topologySet: this.topologySet}
        const dest = this.site + '/synapse/monitoring/getTopology'
        axios
            .get(dest, {params})
            .then(rx => {
                this.topology_data = rx.data.topology
                this.buildTopology()
                this.gettingTopology = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingTopology = false
            });
    },
    buildTopology(){
        this.spacekey += 1
        this.$refs[this.spacename].createTopology(this.topology_data)
    },
    moveRoute(routeName){
        // Protection.
        const cr = this.$route.path
        if (cr != routeName){
            this.$router.push(routeName)
        }
    },
    viewElement(elementData){
        var svbtn = document.getElementById('sv-btn')
        try {
            this.se = elementData.data._model._data.data
        } catch (error) {
            this.se = elementData
        }
        this.sev_mode = 'info'
        // Exclusive for HTML
        //if (this.se.category == 'html'){
        //    var blob_content = new Blob([this.se.content], {type: 'text/html'})
        //    this.se.html_url = URL.createObjectURL(blob_content)
        //    console.log(this.se.html_url)
        //}
        svbtn.click()
    },

    // Graph
    getProbeGraph(){
        this.gettingGraph = true
        this.readyGraph = false
        const params = {uid: this.se.uid, type: this.se.type, samples: this.samplesGraph}
        const dest = this.site + '/synapse/monitoring/getProbeGraph'
        axios
            .get(dest, {params})
            .then(rx => {
                this.pgdata = rx.data.graphData
                this.gettingGraph = false
                this.readyGraph = true
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingGraph = false
                this.readyGraph = false
            });
    },

    getCredentials(){
        this.gettingCredentials = true
        const params = {}
        const dest = this.site + '/synapse/probes/getCredentials' 
        axios
            .get(dest, {})
            .then(rx => {
                // OK
                this.credentials = rx.data.credentials
                this.gettingCredentials = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingCredentials = false
        });
    },
    sendalert(){
        alert(this.nurl.codes_whitelist)
    },

    // Delete
    deleteProbe(_probe, _index){
        this.deletingProbe = true
        // Send request.
        const dest = this.site + '/synapse/probes/deleteProbe' 
        axios
            .post(dest, _probe)
            .then(rx => {
                // OK
                this.deletingProbe = false
                this.probes.splice(_index, 1)
                alert(rx.data.message)
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.deletingProbe = false
        });
    },

    // Addition
    validateProbe(){
        var btn = document.getElementById('trbutton')
        this.blockProbe = true
        this.validatingProbe = true
        if (this.nprobe.type == 'url'){
            this.nurl.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.nurl);
        }
        else if (this.nprobe.type == 'databank'){
            this.ndb.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.ndb);
        }
        // Send request.
        const dest = this.site + '/synapse/probes/validateProbe' 
        axios
            .post(dest, this.probe)
            .then(rx => {
                // OK
                this.validatingProbe = false
                this.blockProbe = false
                this.test_results = rx.data.results
                btn.click()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.blockProbe = false
                this.validatingProbe = false
        });
    },
    addProbe(){
        var btn = document.getElementById('trbutton')
        this.addingProbe = true
        if (this.nprobe.type == 'url'){
            this.nurl.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.nurl);
        }
        else if (this.nprobe.type == 'databank'){
            this.ndb.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.ndb);
        }
        // Send request.
        const dest = this.site + '/synapse/probes/addProbe' 
        axios
            .post(dest, this.probe)
            .then(rx => {
                // OK
                alert(rx.data.message)
                this.addingProbe = false
                this.clearAddition(null)
                btn.click()
                this.getProbes()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.addingProbe = false
        });
    },
    addArgument(){
        if (this.argvalue == null || this.argvalue == ""){
            alert('Empty parameter value.')
            return
        } 
        // Check the max limit.
        if (this.narguments.length >= this.args_limit){
            alert('Parameters limit reached.')
            return
        }
        // Check the type.
        if (this.nprobe.type == 'url' || this.eprobe.type == 'url'){
            if (this.argname == null || this.argname == ""){
                alert('Empty parameter name.')
                return
            } 
            this.narguments.push([this.argname, this.argvalue])
        }
        else if (this.nprobe.type == 'databank' || this.eprobe.type == 'databank'){
            this.narguments.push(this.argvalue)
        }
        this.argname = null
        this.argvalue = null
    },
    removeArgument(idx){
        this.narguments.splice(idx, 1);
    },
    // Add Probe
    setAddition(){
        this.mode = 'addition'
        this.clearAddition(null)
        this.getCredentials()
    },
    clearAddition(probe_type){
        this.probe = {}
        this.nprobe = this.cloneObject(this.dnprobe)
        this.nprobe.type = probe_type
        this.nurl = this.cloneObject(this.dnurl)
        this.ndb = this.cloneObject(this.dndb)
        this.blockProbe = false
        this.addPermission = false
        this.narguments = []
    },
    closeAddition(){
        this.mode = 'default'
    },

    // Edition
    saveProbe(){
        // Send request.
        this.savingProbe = true
        const dest = this.site + '/synapse/probes/saveProbe' 
        axios
            .post(dest, this.eprobe)
            .then(rx => {
                // OK
                alert(rx.data.message)
                this.savingProbe = false
                this.closeEdition()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.savingProbe = false
        });
    },
    setEdition(_probe){
        this.mode = 'edition'
        this.eprobe = _probe
        this.narguments = _probe.args
        console.log(this.eprobe)
    },
    closeEdition(){
        this.mode = 'default'
        this.clearEdition()
    },
    clearEdition(){
        this.eprobe = this.cloneObject(this.deprobe)
        this.narguments = []
        this.argname = null
        this.argvalue = null
        this.nstatuscode = null
    },
    powerProbe(_probe, _index){
        // Send request.
        this.poweringProbe = true
        const dest = this.site + '/synapse/probes/powerProbe' 
        axios
            .post(dest, _probe)
            .then(rx => {
                // OK
                this.probes[_probe.original_index].active = !this.probes[_probe.original_index].active
                //this.getProbes()
                this.poweringProbe = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.poweringProbe = false
        });
    },


    // Filtering
    setSearchType(search_type){
      this.searchType = search_type
      if (search_type == 'name' || search_type == 'alias'){
          this.searchType_ind = search_type
      }
    },

    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = error.error
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  computed: {
    filteredProbes(){
        if (this.searchWord == ''){
            return this.probes
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.probes.filter( probe => String(probe[this.searchType]).toLowerCase().includes( this.searchWord ) );
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getProbes()
  }
}
</script>

<style scoped>

    /* BTN-Synapse */
    .btn-synapse{
        background-color: rgb(108, 194, 225);
        color: Black;
        box-shadow: 0px 0px 8px 0px rgb(249, 249, 249);
        transition-duration: 0.5s;
    }
    .btn-synapse:hover{
        box-shadow: 0px 0px 25px 0px rgb(249, 249, 249);
        color: White;
    }

    .btn-synapse-dark{
        background-color: rgb(0, 54, 73);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(0, 81, 125);
        transition-duration: 0.5s;
    }
    .btn-synapse-dark:hover{
        box-shadow: 0px 0px 25px 0px rgb(0, 81, 125);
        color: rgb(52, 143, 186);
    }

    .bg-synapse-glass{
        box-shadow: inset 0 0 2000px rgba(13, 80, 106, 0.447);
    }
    .bg-glass{
        box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.216);
    }
    .bg-light-glass{
        box-shadow: inset 0 0 1000px rgba(50, 248, 255, 0.108);
    }

    .border-top-synapse{
        border-top: solid 2px rgb(0, 81, 125);
    }
    .border-bottom-synapse{
        border-bottom: solid 2px rgb(0, 81, 125);
    }

    .btn-synapse-danger{
        background-color: rgb(0, 2, 62);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(33, 35, 93);
        transition-duration: 0.5s;
    }
    .btn-synapse-danger:hover{
        box-shadow: 0px 0px 25px 0px rgb(1, 28, 43);
        color: rgb(255, 0, 0);
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 20px;
        cursor: pointer;
        box-shadow: 0px 0px 0px #000000;
        background: rgb(0, 54, 73);
        border-radius: 15px;
        border: 0px solid #000101;
    }
    input[type=range]::-webkit-slider-thumb {
        box-shadow: 0px 0px 0px #000000;
        border: 1px solid #000000;
        height: 30px;
        width: 40px;
        border-radius: 40px;
        background: rgb(108, 194, 225);
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -3.5px;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

    /* Table with static header */
    .tableFixHead {
        overflow-y: auto;
        overflow-x: hidden;
        }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
        text-align: center;
        z-index: 1;
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th, td {
        padding: 8px 16px;
    }
    th {
        background: #eee;
    }

</style>
